import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import type { MouseEvent, ReactNode } from 'react'
type Props = {
  icon: ReactNode
  onClick: () => void
  className?: string
}

export const HoverEditButton = ({ icon, onClick, className }: Props) => {
  const handleClick = (evt: MouseEvent) => {
    evt.preventDefault()
    evt.stopPropagation()

    onClick()
  }

  return (
    <div
      className={cx(
        'cursor-pointer rounded-md p-1 hover:opacity-80',
        paperStyles({ isFaded: false }),
        className,
      )}
      role="button"
      onClick={handleClick}
    >
      {icon}
    </div>
  )
}
